import { render, staticRenderFns } from "./ProfileTalentAvailabilityGrandChildOpportunityItem.vue?vue&type=template&id=59ade23e&scoped=true"
import script from "./ProfileTalentAvailabilityGrandChildOpportunityItem.vue?vue&type=script&lang=js"
export * from "./ProfileTalentAvailabilityGrandChildOpportunityItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ade23e",
  null
  
)

export default component.exports